// extracted by mini-css-extract-plugin
module.exports = {"copy":"orbit-container_copy__scovC"};